<template>
    <v-autocomplete
        v-model="airlineCode"
        :items="items"
        :loading="loading"
        hide-no-data
        hide-selected
        item-value="code"
        :label="label"
        no-filter
        clearable
        :rules="rules"
        :disabled="disabled"
        :outlined="outlined"
        :hide-details="hideDetails"
        :single-line="singleLine"
        :density="dense ? 'compact' : 'comfortable'"
        @update:search="onSearch"
    >
        <template v-slot:item="{item, props}">
            <v-list-item v-bind="props" prepend-icon="mdi-airplane-takeoff">
                <template v-slot:title>
                    {{ itemText ? `${item.raw[itemText]}` : `${item.raw.name && item.raw.name.en}` }}
                </template>
            </v-list-item>
        </template>
        <template v-slot:selection="{item}">
            {{ itemText ? `${item.raw[itemText]}` : `${item.raw.name && item.raw.name.en}` }}</template
        >
    </v-autocomplete>
</template>

<script lang="ts">
    import {Component, mixins, Prop, VModel} from 'vue-facing-decorator'
    import {AirlinesSearchMixin} from '@/mixins/AirlinesSearchMixin.vue'

    @Component
    export class AirlinesSearchInput extends mixins(AirlinesSearchMixin) {
        @VModel() airlineCode
        @Prop() rules
        @Prop() label
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) outlined
        @Prop({default: false, type: [Boolean, String]}) hideDetails
        @Prop({default: false, type: Boolean}) singleLine
        @Prop({default: false, type: Boolean}) dense
        @Prop({default: null}) itemText
        @Prop({default: 'POPULARITY'}) orderBy

        items = []
        search = null
        loading = false
        timer = null

        onSearch(val) {
            this.search = val
            if (!val) return
            if (this.timer) {
                clearTimeout(this.timer)
            }
            this.timer = window.setTimeout(() => {
                this.initSearch({
                    pattern: val,
                    orderBy: this.orderBy,
                })
            }, 400)
        }

        async mounted() {
            await this.$store.restored
            if (this.airlineCode) {
                await this.initSearch({
                    airlineCode: this.airlineCode,
                })
            }
        }

        async initSearch(rq) {
            this.loading = true
            try {
                this.items = (await this.searchAirlines(rq)).map(airline => ({
                    code: airline.codes.IATA || airline.codes.SUPPL,
                    ...airline,
                }))
            } finally {
                this.loading = false
            }
        }
    }

    export default AirlinesSearchInput
</script>
